import { useQuery } from '@tanstack/react-query';
import { getDocument } from '../services/fn-api/Cases';
import { DOCUMENT_KEY } from 'src/utils/constants/queryKeys';

export const useGetDocument = (id: string) => {
  return useQuery({
    queryKey: [DOCUMENT_KEY, id],
    queryFn: () => getDocument(id),
    enabled: !!id,
    staleTime: 0,
  });
};
